import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { LayoutModule } from './layout/layout.module';
import { AppRoutingModule } from './app-routing.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DashboardModule } from './dashboard/dashboard.module';
import { HomeModule } from './home/home.module';
import { AboutModule } from './about/about.module';
import { VerifyEmailModule } from './verify-email/verify-email.module';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './verify-email/services/auth-interceptor';
import { MatIconModule, MatTableModule } from '@angular/material';
import { VerifyEmailService } from './verify-email/services/verify-email.service';
import { AuthService } from './verify-email/services/auth.service';
import { ConfigService } from './verify-email/services/config-service';

export function initConfig(configService: ConfigService) {
    return () => configService.loadConfig();
}

@NgModule({
    declarations: [
        AppComponent,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    imports: [
        BrowserModule,
        MatTableModule,
        MatIconModule,
        RouterModule.forRoot([]),
        ModalModule.forRoot(),
        AppRoutingModule,
        FlexLayoutModule,
        LayoutModule,
        DashboardModule,
        HomeModule,
        AboutModule,
        VerifyEmailModule
    ],
    providers: [
        BsModalService,
        VerifyEmailService,
        AuthService,
        {
            provide: APP_INITIALIZER,
            useFactory: initConfig,
            deps: [ConfigService],
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
